
const SnsMini = require("./SnsMini")

let sns = xClass("snsVivoQuickgame", SnsMini)

let vivoVideoPosIdList = [
    "13c5350f1fd849538ce2002ba6104c04",
    "c48981935d844fe58cf581b91f451295",
    "53f634f6c9104275864038af94557c61",
    "2083f7703caf4c02a60a2bac843a2326"
]
let videoLen = $len(vivoVideoPosIdList)

sns.prototype.ctor = function() {
    SnsMini.prototype.ctor.call(this);
    //this._adDcName = 'oppo_video_ad';
    //mini.initAd("30098064");
}

sns.prototype.initAd = function() {
    console.log("@@@@no need initad ")
}
// /**
//  * 预加载广告
//  */
// sns.prototype.prepareAd = function(adPos = 0) {
//     console.log("@@@@run prepare ad")
//     let ad = mini.createRewardedVideoAd(this._translateAdPos(adPos), handler(this, this.finishSaveByGridAd));

//     if (ad == null) {
//         return Promise.reject({ errMsg: getText("video.ad.error") })
//     }

//     return ad.load().catch(err=> {
//         console.error(`${this._adDcName || 'snsVivoMini'} loadRewardedVideoAd! err = ${err? err.errMsg: ''}`);
//         if (this._adDcName)
//             DCAssist.userTrack(this._adDcName, "noAds");
//         if (window.logCenter) {
//             logCenter.error(new Error(`${this._adDcName || 'snsMini'} prepareAd failed! err = ${err? err.errMsg: ''}`), 'AdError')
//             }
//         return Promise.reject({
//             errMsg: getText("video.ad.error")
//         });    
//     })
// }

// /**
//  * 显示广告
//  * 
//  */
// sns.prototype.showAd = function(adPos = 0) {1
//     var self = this

//     console.log("@@@@showad run:"+adPos)
//     let ad = mini.createRewardedVideoAd(this._translateAdPos(adPos), handler(this, this.finishSaveByGridAd));

//     //return Promise.reject({ errMsg: getText("video.ad.error") })
//     if (ad == null) {
//         console.log("@@@@ad is null reject")
//         return Promise.reject({ errMsg: getText("video.ad.error") })
//     }
//     self.isMusicOpen = MusicPlayer.getInstance().IsBackgroundMusicOpen
//     if (self.isMusicOpen)
//         MusicPlayer.getInstance().pauseBackgroundMusic()

//     return new Promise((resolve, reject)=>{
//         ad.load().then(
//             ()=>{
//                 ad.show().then(
//                 isEnd => {
//                     resolve(isEnd)
//                     if (self.isMusicOpen)
//                         MusicPlayer.getInstance().resumeBackgroundMusic()
//                 }).catch(err=> {
//                     console.log("@@@@catch showad error reject")
//                     if (self.isMusicOpen)
//                         MusicPlayer.getInstance().resumeBackgroundMusic()
//                     console.error(`${this._adDcName || 'snsVivoMini'} playRewardedVideoAd! err = ${err? err.errMsg: ''}`);
//                     if (this._adDcName)
//                         DCAssist.userTrack(this._adDcName, "noAds");
//                     if (window.logCenter) {
//                         logCenter.error(new Error(`${this._adDcName || 'snsMini'} showAd failed! err = ${err? err.errMsg: ''}`), 'AdError')
//                     }
//                     if (reject){
//                         reject()
//                     }
//                 })
//             }
//         ).catch(err=> {
//             console.log("@@@@catch load ad error reject")
//             if (self.isMusicOpen)
//                 MusicPlayer.getInstance().resumeBackgroundMusic()
//             console.error(`${this._adDcName || 'snsVivoMini'} playRewardedVideoAd! err = ${err? err.errMsg: ''}`);
//             if (this._adDcName)
//                 DCAssist.userTrack(this._adDcName, "noAds");
//             if (window.logCenter) {
//                 logCenter.error(new Error(`${this._adDcName || 'snsMini'} showAd failed! err = ${err? err.errMsg: ''}`), 'AdError')
//             }
//             if (reject){
//                 reject()
//             }
//         })
//     }) 
// }

/**
 * 转译广告位
 */
sns.prototype._translateAdPos = function(adPos = "FailAdd1Step", useDefaultId = false) {
    if (typeof adPos != "number" || adPos >= videoLen || adPos < 0)
        adPos = 0

    return vivoVideoPosIdList[adPos];
}

sns.prototype.getOpenKey = function (cb) {
    var self = this
    
    let accessToken = cc.UserDefault.getInstance().getStringForKey("access_token")
    let refreshToken = cc.UserDefault.getInstance().getStringForKey("refresh_token")
    
    //TODO:vivo使用refreshtoken去刷新accesstoken接口有问题，后端获取不到新的accesstoken，故屏蔽使用accesstoken登陆的方法
    //使用本地缓存登陆
    if (accessToken && refreshToken && false){
        cb({
            access_token:accessToken,
            refreshToken:refreshToken
        })
    }
    //使用code登陆
    else{
        self.loginFail = null

        mini.login({
            type: "code",
            success: function (obj) {
                console.log("[####]vivo success code=", obj.code)
                cb({
                    code:obj.code,
                    op:"access_token"
                })
            },
            fail: function (data, code) {
                console.log("[####]vivo fail")
                self.loginFail = true
                mini.showToast({
                    title: "登陆失败，请退出重试"
                })
                cb({
                    failRetry:1,
                    op:"access_token"
                })
            }
        })

    }
    /*mini.login({
        success:(res)=>{
            console.log("login success data:"+JSON.stringify(res.data))
            //token = res.data.token
            META.tokenid = res.data.token
            if (cb){
                cb({   
                    pkgName:"com.happyelements.clover.h5.nearme.gamecenter",
                    token:res.data.token
                })
            }
        },
        fail:(res)=>{
            console.log("login failed")
        }
    })*/


    return
}

sns.prototype.onLoginFinish = function(openid, sessionid){
    console.log("[####]oppo login finish openid:"+openid+" sess:"+sessionid)
    if (openid && sessionid){
        META.user.openid = openid
        META.user.sessionid = sessionid
        //cc.UserDefault.getInstance().setStringForKey("h5game_openid", openid)
        //cc.UserDefault.getInstance().setStringForKey("h5sdk_sessionid", sessionid)
    }else{
        console.log("[####]oppo login finish failed no openid or sessionid")
    }

}
sns.prototype.openUrl = function () {
    // 微信不能跳转
}

sns.prototype.hideKeyboard = function () {
    // 微信不能跳转
    //mini.hideKeyboard()
}

sns.prototype.share = function (textId, platform, title, imageUrl, _link, callback) {
    
}

sns.prototype.popBack = function () {
    //mini.exitMiniProgram({})
}

sns.prototype.alert = function (content, onClickOk) {
    /*mini.showModal({
        showCancel: false,
        content: content,
        success: onClickOk
    })*/
}

sns.prototype.drawDataToImg = function (bgpath, info, callback) {

}

sns.prototype.showGridAd = function(config){
    console.warn("not support grid ad");
}

/**
 * 显示插屏广告用
 */
sns.prototype.setNeedShowInterstitialAdName = function(name, flag) {
    if (!this.needShowInterstitialAdName){
        this.needShowInterstitialAdName = [];
    }
    this.needShowInterstitialAdName[name] = flag;
}

sns.prototype.getNeedShowInterstitialAdName = function(name) {
    cc.log(this.needShowInterstitialAdName)
    if (!this.needShowInterstitialAdName){
        this.needShowInterstitialAdName = [];
    }
    return this.needShowInterstitialAdName[name];
}

module.exports = sns